<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">

		<clients-select v-model="form.client_id"></clients-select>
		<smart-input :error="inputErrors.name" :label="$t('pages.branchForm.branchName')" v-model="form.name"></smart-input>
		<smart-input :error="inputErrors.directory_name" :label="$t('attributes.directoryName')" v-model="form.directory_name"></smart-input>
		<smart-input :error="inputErrors.postal" :label="$t('pages.clientTable.zipCode')" v-model="form.postal"></smart-input>
		<smart-input :error="inputErrors.address" :label="$t('pages.projectForm.address')" v-model="form.address"></smart-input>
		<smart-input :error="inputErrors.city" :label="$t('pages.projectForm.city')" v-model="form.city"></smart-input>
		<smart-input :error="inputErrors.contact_man" :label="$t('pages.projectForm.contact')" v-model="form.contact_man"></smart-input>
		<smart-input :error="inputErrors.tel" :label="$t('pages.orderTable.tel')" v-model="form.tel"></smart-input>
		<smart-input :error="inputErrors.email" :label="$t('attributes.email')" v-model="form.email"></smart-input>
		<div class="form-group">
			<v-btn type="submit" color="success">שמירה</v-btn>
		</div>
	</form>
</template>


<script>
	import BranchModule from "src/store/modules/Branch.module";
	import FormView from "src/mixins/FormView";
	import ClientsSelect from "dev/view/clients/ClientsSelect";

	export default {
		props: [],
		name: "branch-form",
		components: {ClientsSelect},
		data() {
			return {
				form: {
					name: null,
				},
			};
		},
		mixins: [new FormView(BranchModule, "branch")],
		computed: {
			isNew() {
				return !!this.branch.id;
			}
		}
	};
</script>

<style>


</style>
